import React from 'react';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'ghost' | 'soft' | 'danger';
  size?: 'sm' | 'md';
  children: React.ReactNode;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ variant = 'ghost', size = 'md', className, children, ...props }, ref) => {
    const baseClasses =
      'inline-flex items-center justify-center rounded-full transition focus-visible:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-60';

    const variantClasses = {
      ghost: 'text-[#6B6560] hover:bg-[#EEF4FB] hover:text-[#185FA5] focus-visible:ring-[rgba(24,95,165,0.12)]',
      soft: 'border border-[#D7D3CC] bg-[#FFFFFF] text-[#6B6560] hover:bg-[#F9F7F4] hover:text-[#185FA5] focus-visible:ring-[rgba(24,95,165,0.12)]',
      danger: 'bg-[#C64535] text-white hover:bg-[#A93325] focus-visible:ring-[rgba(198,69,53,0.16)]',
    };

    const sizeClasses = {
      sm: 'h-8 w-8 p-1.5',
      md: 'h-9 w-9 p-2',
    };

    return (
      <button
        ref={ref}
        className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className || ''}`}
        {...props}
      >
        {children}
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';
